import React, { useMemo } from 'react';
import EntityField from '../internal/EntityField';
import FormPasswordValidation from '../../../controls/FormPasswordValidation';
import useEntityFormContext from '../internal/useEntityFormContext';
const constraints = {
    password: {
        length: (errors) => ({
            maximum: 0,
            message: errors,
        }),
    },
    confirmation: {
        length: (errors) => ({
            maximum: 0,
            message: errors,
        }),
    },
};
const PasswordValidationField = ({ name, passwordFieldName, passwordConfirmationFieldName, ...rest }) => {
    const { values } = useEntityFormContext();
    const password = useMemo(() => values[passwordFieldName], [
        passwordFieldName,
        values,
    ]);
    const passwordConfirmation = useMemo(() => values[passwordConfirmationFieldName], [passwordConfirmationFieldName, values]);
    return (<EntityField name={name} {...rest} multipleValues constraints={constraints}>
      {(editing, field) => (<FormPasswordValidation {...field} password={password} passwordConfirmation={passwordConfirmation}/>)}
    </EntityField>);
};
export default PasswordValidationField;
